"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _1 = require("./");
var simplePropertyMappers_1 = require("./simplePropertyMappers");
var SwitchCaseModelMapper = /** @class */function (_super) {
  __extends(SwitchCaseModelMapper, _super);
  function SwitchCaseModelMapper(options) {
    var _this = _super.call(this) || this;
    var _a = options || {},
      _b = _a.kebabizeAttributes,
      kebabizeAttributes = _b === void 0 ? true : _b,
      _c = _a.kebabizeRelationships,
      kebabizeRelationships = _c === void 0 ? true : _c,
      _d = _a.kebabizeType,
      kebabizeType = _d === void 0 ? true : _d;
    _this.kebabizeAttributes = kebabizeAttributes;
    _this.kebabizeRelationships = kebabizeRelationships;
    _this.kebabizeType = kebabizeType;
    return _this;
  }
  SwitchCaseModelMapper.prototype.getType = function (model) {
    var type = _super.prototype.getType.call(this, model);
    if (!this.kebabizeType || !type) {
      return type;
    }
    return type.replace(/([a-z][A-Z0-9])/g, function (g) {
      return g[0] + '-' + g[1].toLowerCase();
    });
  };
  SwitchCaseModelMapper.prototype.getAttributes = function (model) {
    var camelCasedAttributes = _super.prototype.getAttributes.call(this, model);
    if (!this.kebabizeAttributes || !camelCasedAttributes) {
      return camelCasedAttributes;
    }
    var kebabAttributes = {};
    Object.keys(camelCasedAttributes).forEach(function (name) {
      var kebabName = name.replace(/([a-z][A-Z0-9])/g, function (g) {
        return g[0] + '-' + g[1].toLowerCase();
      });
      kebabAttributes[kebabName] = camelCasedAttributes[name];
    });
    return kebabAttributes;
  };
  SwitchCaseModelMapper.prototype.getRelationships = function (model) {
    var camelCasedRelationships = _super.prototype.getRelationships.call(this, model);
    if (!this.kebabizeRelationships || !camelCasedRelationships) {
      return camelCasedRelationships;
    }
    var kebabRelationships = {};
    Object.keys(camelCasedRelationships).forEach(function (name) {
      var kebabName = name.replace(/([a-z][A-Z0-9])/g, function (g) {
        return g[0] + '-' + g[1].toLowerCase();
      });
      kebabRelationships[kebabName] = camelCasedRelationships[name];
    });
    return kebabRelationships;
  };
  return SwitchCaseModelMapper;
}(_1.ModelPropertiesMapper);
exports.SwitchCaseModelMapper = SwitchCaseModelMapper;
var SwitchCaseJsonMapper = /** @class */function (_super) {
  __extends(SwitchCaseJsonMapper, _super);
  function SwitchCaseJsonMapper(options) {
    var _this = _super.call(this) || this;
    var _a = options || {},
      _b = _a.camelizeAttributes,
      camelizeAttributes = _b === void 0 ? true : _b,
      _c = _a.camelizeRelationships,
      camelizeRelationships = _c === void 0 ? true : _c,
      _d = _a.camelizeType,
      camelizeType = _d === void 0 ? true : _d;
    _this.camelizeAttributes = camelizeAttributes;
    _this.camelizeRelationships = camelizeRelationships;
    _this.camelizeType = camelizeType;
    return _this;
  }
  SwitchCaseJsonMapper.prototype.createModel = function (type) {
    if (!this.camelizeType) {
      return {
        type: type
      };
    }
    var camelizedType = type.replace(/-([a-z0-9])/g, function (g) {
      return g[1].toUpperCase();
    });
    return {
      type: camelizedType
    };
  };
  SwitchCaseJsonMapper.prototype.setAttributes = function (model, attributes) {
    if (!this.camelizeAttributes) {
      return _super.prototype.setAttributes.call(this, model, attributes);
    }
    Object.keys(attributes).forEach(function (propName) {
      var camelName = propName.replace(/-([a-z0-9])/g, function (g) {
        return g[1].toUpperCase();
      });
      model[camelName] = attributes[propName];
    });
  };
  SwitchCaseJsonMapper.prototype.setRelationships = function (model, relationships) {
    // call super.setRelationships first, just for not to copy paste setRelationships logic
    _super.prototype.setRelationships.call(this, model, relationships);
    if (!this.camelizeRelationships) {
      return;
    }
    // then change relationship names case if needed
    model[simplePropertyMappers_1.RELATIONSHIP_NAMES_PROP].forEach(function (kebabName, i) {
      var camelName = kebabName.replace(/-([a-z]|[0-9])/g, function (g) {
        return g[1].toUpperCase();
      });
      if (camelName !== kebabName) {
        model[camelName] = model[kebabName];
        delete model[kebabName];
        model[simplePropertyMappers_1.RELATIONSHIP_NAMES_PROP][i] = camelName;
      }
    });
  };
  return SwitchCaseJsonMapper;
}(_1.JsonPropertiesMapper);
exports.SwitchCaseJsonMapper = SwitchCaseJsonMapper;